import React, { Component } from "react";
import styled from "styled-components";

import {
  GridContent,
  SectionTitle,
  InnerContent,
} from "../../../pages/Ems/Main";

import Table from "../test/Table";

class SystemInfo extends Component {
  // constructor(props) {}

  render() {
    return (
      <GridContent>
        <SectionTitle>시스템 정보</SectionTitle>
        <InnerContent>
          <TableArea>
            <p>시간/날씨</p>
            <Table
              colgroup={"1fr 1fr"}
              theadList={["날짜", "시간"]}
              tbodyList={["24-01-01", "PM 13:00"]}
            />
          </TableArea>
          <TableArea>
            <p>블루배터리 사양</p>
            <Table
              colgroup={"1fr 1fr 1fr"}
              theadList={["용량", "전압", "전류"]}
              tbodyList={["256 Ah", "256 V", "21 A"]}
            />
          </TableArea>
          <TableArea>
            <p>태양광 사양</p>
            <Table
              colgroup={"1fr 1fr 1fr"}
              theadList={["용량", "전압", "전류"]}
              tbodyList={["256 Ah", "256 V", "21 A"]}
            />
          </TableArea>
          <TableArea>
            <p>전력기기 사양</p>
            <Table
              colgroup={"1fr 1fr 1fr"}
              theadList={["용량", "전압", "전류"]}
              tbodyList={["256 Ah", "256 V", "21 A"]}
            />
          </TableArea>
        </InnerContent>
      </GridContent>
    );
  }
}
const TableArea = styled.div`
  margin-bottom: 10px;
  p {
    margin-bottom: 5px;
  }
`;
export default SystemInfo;
